import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { SchoolDayUpdateRequest } from "./SchoolDayUpdateRequest";

@Injectable()
export class DataService_SchoolDaySetup {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	LoadSchoolDay(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/LoadSchoolDay?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadBellSchedule(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/LoadBellSchedule?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolDayUpdate(parms: SchoolDayUpdateRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/SchoolDayUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolDayMoveUp(CurrentDayID, PreviousDayID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/SchoolDayMoveUp?CurrentDayID=" + CurrentDayID + "&PreviousDayID=" + PreviousDayID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolDayMoveDown(CurrentDayID, NextDayID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/SchoolDayMoveDown?CurrentDayID=" + CurrentDayID + "&NextDayID=" + NextDayID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
